type PartialOf<T> = { [key in keyof T]?: [T[key], string, string?][] }

// TODO: generate from dts

const status: [Ccd.Question['status'], string][] = [
  ['normal', '正常'],
  ['disabled', '停用'],
]

export const Trainee: PartialOf<Ccd.Trainee> = {
  status: [
    ['normal', '正常', 'primary'],
    ['disabled', '停用', 'info'],
  ],
  stage: [
    // ['unverified', '未验证'],
    ['verified', '培训中', 'primary'],
    ['passed', '已通过', 'success'],
    ['failed', '未通过', 'danger'],
  ],
  gender: [
    ['male', '男'],
    ['female', '女'],
  ],
}

export const Agent: PartialOf<Ccd.Agent> = {
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
}

export const Site: PartialOf<Ccd.Site> = {
  sellMode: [
    ['service', '服务模式'],
    ['device', '整机售卖模式'],
    ['wechat', '微信小程序'],
  ],
}

export const subject: [Ccd.Subject, string][] = [
  ['科目一', '科目一'],
  ['科目四', '科目四'],
  ['满分复活', '满分复活'],
  ['三力测试', '三力测试'],
  ['注销恢复', '注销恢复'],
]

export const SUBJECTS = subject.map(item => item[0])

export const carModel: [Ccd.CarModel, string][] = [
  ['C1/C2/C3', '小车'],
  ['A2/B2', '货车'],
  ['A1/A3/B1', '客车'],
  ['D/E/F', '摩托车'],
]

export const CAR_MODELS = carModel.map(item => item[0])

export const Question: PartialOf<Ccd.Question> = {
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
  type: [
    ['multiple', '多选'],
    ['single', '单选'],
    ['judge', '判断'],
  ],
  tags: [
    ['速成1', '速成1'],
    ['速成2', '速成2'],
    ['速成3', '速成3'],
    ['速成4', '速成4'],
    ['速成5', '速成5'],
    ['速成6', '速成6'],
    ['速成7', '速成7'],
    ['速成8', '速成8'],
    ['速成9', '速成9'],
    ['速成10', '速成10'],
    ['考前必学', '考前必学'],
    ['速度题', '速度题'],
    ['交警手势', '交警手势'],
    ['驾驶证申领与使用', '驾驶证申领与使用'],
    ['机动车等级与使用', '机动车等级与使用'],
    ['交通事故处理', '交通事故处理'],
    ['交通信号灯', '交通信号灯'],
    ['灯光使用', '灯光使用'],
    ['常识题', '常识题'],
    ['道路通行原则', '道路通行原则'],
    ['高速公路通行', '高速公路通行'],
    ['机械常识', '机械常识'],
    ['选学文字题', '选学文字题'],
    ['选择图片题', '选择图片题'],
    ['考前练习', '考前练习'],
  ] as any,
}

export const TraineeRecord: PartialOf<Ccd.TraineeRecord> = {
  mode: [
    ['zxlx', '专项练习'],
    ['jjtk', '精简题库'],
    ['favor', '收藏集'],
    ['wrong', '错题集'],
    ['sim', '模拟考试'],
  ],
}

export const Admin: PartialOf<Ccd.Admin> = {
  status,
}

export const Order: PartialOf<Ccd.Order> = {
  status: [
    ['pending', '待支付'],
    ['done', '已完成'],
    ['refunding', '退款中'],
    ['refunded', '已退款'],
    ['closed', '已关闭'],
  ],
}

export const Transaction: PartialOf<Ccd.Transaction> = {
  type: [
    ['topup', '充值'],
    ['refund', '退款'],
  ],
  channel: [
    ['wechat', '微信'],
    ['alipay', '支付宝'],
  ],
  status: [
    ['pending', '待支付'],
    ['paid', '已支付'],
    ['refunding', '退款中'],
    ['refunded', '已退款'],
    ['closed', '已关闭'],
  ],
}

export const RefundResult: PartialOf<Ccd.RefundResult> = {
  status: [
    ['SUCCESS', '成功'],
    ['CLOSED', '关闭'],
    ['PROCESSING', '退款中'],
    ['ABNORMAL', '退款异常'],
  ],
  channel: [
    ['ORIGINAL', '原路退款'],
    ['BALANCE', '退回到余额'],
    ['OTHER_BALANCE', '原路退款至其他余额账户'],
    ['OTHER_BANKCARD', '原路退款至其他银行卡'],
  ],
  funds_account: [
    ['UNSETTLED', '未结算资金'],
    ['AVAILABLE', '可用余额'],
    ['UNAVAILABLE', '不可用余额'],
    ['OPERATION', '运营户'],
    ['BASIC', '基本账户（含可用余额和不可用余额'],
    ['ECNY_BASIC', '数字人民币基本账户'],
  ],
}

export const Wechat: PartialOf<Ccd.WechatDoc> = {
  type: [
    ['mini', '小程序'],
    ['wx', '公众号'],
  ],
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
}

export const Mch: PartialOf<Ccd.Mch> = {
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
}

export const User: PartialOf<Ccd.UserDoc> = {
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
}

export const Product: PartialOf<Ccd.ProductDoc> = {
  status: [
    ['normal', '正常'],
    ['disabled', '停用'],
  ],
  type: [
    ['vip', '会员'],
    ['course', '课程'],
  ],
}

export const EnvVersion: [WxApi.UnlimitedQRCodeConfig['env_version'], string][] = [
  ['release', '正式版'],
  ['trial', '体验版'],
  ['develop', '开发版'],
]

export const WithdrawRecord: PartialOf<Ccd.WithdrawRecord> = {
  status: [
    ['pending', '待支付'],
    ['done', '已完成'],
    ['rejected', '已拒绝'],
    ['failed', '失败'],
  ],
}

export const TRAINEE_MODES = ['wxHome', 'zxlx', 'jjtk', 'wrong', 'favor', 'sim'] as const

export const SELL_MODES = ['service', 'device', 'wechat'] as const

export const WX_HOME_TAGS: Ccd.WxHomeTag[] = ['模拟考试', '顺序练习', '考前秘卷', '精选题', '易错题'] as const

export const PRODUCT_TAGS: Ccd.ProductTag[] = ['VIP课程', '考前秘卷', '精选题'] as const
